/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import { useTranslation } from 'react-i18next';

const conversionTable = {
    // The Array(X) is mapping the number of items in each key
    // see the translation to understard what each key means
    months: [...Array(12).keys()].map(x => ++x),
    currency: [...Array(12).keys()].map(x => ++x),

    // User
    age: [...Array(10).keys()].map(x => ++x),
    gender: [...Array(3).keys()].map(x => ++x),
    ecosystemRole: [...Array(17).keys()].map(x => ++x),

    // Company
    companySize: [...Array(5).keys()].map(x => ++x),
    companyType: [...Array(9).keys()].map(x => ++x),

    challenge: [...Array(23).keys()].map(x => ++x),
    community: [...Array(21).keys()].map(x => ++x),
    expertise: [...Array(22).keys()].map(x => ++x),
    industry: [...Array(28).keys()].map(x => ++x),
    innovationType: [...Array(20).keys()].map(x => ++x),
    interestArea: [...Array(76).keys()].map(x => ++x),
    trend: [...Array(71).keys()].map(x => ++x),

    // Investor
    investorType: [
        'angel',
        'angelnetwork',
        'accelerator',
        'familyoffice',
        'venturecapital',
        'corporateventure',
    ],
    howCanContribute: [
        'experienceinvestor',
        'experiencesector',
        'experienceentrepreneur',
        'contactnetwork',
    ],

    // Investments
    investmentType: ['Angel', 'Seed', 'Venture', 'Corporate', 'Grant', 'Debt', 'Other'],

    yesNo: [true, false],
};

export function useConversionTable(items) {
    const { t } = useTranslation('conversionTable');
    const returnTable = {};

    // Find the conversionTable required by function
    items.map(i => {
        returnTable[i] = {};
        const keys = conversionTable[i];
        return keys.map(k => {
            // i18next-extract-disable-next-line
            returnTable[i][k] = t(`${i}.${k}`);
            return returnTable[i][k];
        });
    });

    return returnTable;
}

export function useConversionOptions(items) {
    const convertedTable = useConversionTable(items);
    const returnTable = {};

    // Format the array to name:value format
    Object.keys(convertedTable).map(i => {
        returnTable[i] = [];
        const keys = Object.keys(convertedTable[i]);
        // Push the formated objects to the array
        return keys.map(k => {
            // return returnTable[i][k];
            return returnTable[i].push({ name: convertedTable[i][k], value: k });
        });
    });

    return returnTable;
}
